import { memo, ReactNode } from "react";
import { useElement, useLocale } from "../../../hooks";
import { useModal } from "./hooks";

interface ModalProps {
  id?: string;
  children?: ReactNode;
  dismissable?: boolean;
  showCancel?: boolean;
  showSuccess?: boolean;
  successButtonLabel?: string;
  cancelButtonLabel?: string;
  onSuccess?: () => void;
  onCancel?: () => void;
  showModal?: boolean;
}

export const Modal = memo(
  ({
    id = String(new Date().getTime()),
    children,
    dismissable = true,
    showCancel = true,
    showSuccess = true,
    successButtonLabel,
    cancelButtonLabel,
    onSuccess,
    onCancel,
    showModal,
  }: ModalProps) => {
    const { t } = useLocale();
    const Button = useElement("Button");
    const { onCancelButtonClick, onSuccessButtonClick } = useModal({
      showModal,
      onCancel,
      onSuccess,
    });
    return (
      <div className={showModal ? "modal open" : "modal"} id={id}>
        <div className="modal-backdrop"></div>
        <div className="modal-content small">
          {dismissable && (
            <Button className="close" onClick={onCancelButtonClick}>
              <i className="hi-close"></i>
            </Button>
          )}
          <div className="modal-header"></div>
          <div className="modal-body">
            {children ?? t("defaultModalContent")}
          </div>
          {(showSuccess || showCancel) && (
            <div className="modal-footer">
              {showSuccess && (
                <Button
                  className="btn btn-primary"
                  onClick={onSuccessButtonClick}
                >
                  {successButtonLabel ?? t("delete")}
                </Button>
              )}
              {showCancel && (
                <Button
                  className="btn btn-outline"
                  onClick={onCancelButtonClick}
                >
                  {cancelButtonLabel ?? t("cancel")}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
);
